/* eslint-disable array-callback-return */
import { useEffect, useMemo, useRef, useState } from 'react';
import { Singleton } from '../../../core/services/Singleton';
import "./basictable.css";
import { env } from '../../../env';
import { HeadMultiSelectTable } from './basicMultiSelectTable/HeadMultiSelectTable';
import { TableMultiSelectCell } from './basicMultiSelectTable/TableMultiSelectCell';
import { PrintJson } from './PrintJson';
import { toast } from 'react-toastify';


export const MASK_NUMBER = 1;
export const MASK_NUMBER_ROUND = 11;
export const MASK_MONEY = 2;
export const MASK_MONEY_ROUND = 22;
export const MASK_TEXT = 3;
export const MASK_TEXT_NOWRAP = 33;
export const MASK_MYEDITOR = 4;
export const MASK_DATE = 5;
export const MASK_DATE_DDMMMYYYY = 6;
export const MASK_BOOLEAN_ICON = 7;

interface paginadorProps {
    page: number,
    pages: number,
    records: number,
    regiPerPage: number,
    setRegiPerPage: Function,
    setPage: Function,
    setPages: Function,
    setRecords: Function,
}

interface Props {
    head: any,
    body: any;
    bodyResult: any;
    keyId: string;
    pageTop?: number;
    records?: Partial<paginadorProps>;
    next?: any;
    back?: any;
    registersPerPage?: number;
    cssTable?: string;
    customRows?: number;
    _returnCellValue?: Function;
    updateValues: (data: { bodyResult: any[] }) => void;
    sumPropsList?: any;
    clearnotListBody?: boolean;
    setRowBean?: Function;
    headButtons?: any;
}

export const BasicMultiSelectTable = ({ head, body, keyId, bodyResult, pageTop, records, next, back, registersPerPage, cssTable, customRows, _returnCellValue, updateValues, sumPropsList, clearnotListBody, setRowBean, headButtons }: Props) => {

    const [rowData, setRowData] = useState<any>({});
    const [mbody, setMbody] = useState<any>([]);
    const [mbodyResult, setMbodyResult] = useState<any>([]);
    const [titulo, setTitulo] = useState<any>([]);
    const single = Singleton.getInstance()
    const [currentIndex, setCurrentIndex] = useState(0);

    //paginador
    const [page, setPage] = useState<number>(1);
    const [rows, setRows] = useState<number>(15);

    const printLog = env.PRINT_LOG ?? false;

    useEffect(() => {
        if (customRows) {
            setRows(customRows);
            paginar();
        }
    }, [customRows]);

    useEffect(() => {
        if (updateValues && !deepEqual(bodyResult, mbodyResult)) {
            updateValues({ bodyResult: [...mbodyResult] });
        }

    }, [mbodyResult, updateValues, bodyResult]);

    const deepEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

    useEffect(() => {
        if (registersPerPage > 0 && body.length > 0) {
            setRows(registersPerPage)
        }
    }, [registersPerPage]);

    useEffect(() => {
        if (page > 0) {
            paginar();
            let t = single.currentURI;
        }
    }, [page, rows]);

    useEffect(() => {
        if (body) {
            updateTitulo();
            paginar();
            if (!clearnotListBody) {
                setMbodyResult([]);
            }
        }
    }, [body]);


    const updateTitulo = () => {
        if (head) {
            head.forEach((element: any) => {
                if (element.visible === undefined) {
                    element.visible = true;
                }
            });
            setTitulo(head);
        }
    }

    useEffect(() => {
        if (Array.isArray(bodyResult) && bodyResult.length > 0) {
            setMbodyResult(bodyResult);
        }
    }, [bodyResult]);

    const paginar = () => {
        try {
            let sup = (page <= 1 ? rows : page * rows);
            let inf = sup - rows;

            setMbody(body.slice(inf, sup));
        } catch (error) {
        }
    }

    const onClickCell = (value: any) => {
        if (_returnCellValue) {
            _returnCellValue(value);
        }
    }

    const removeItem = (id: number) => {
        const updatedMultiValue = mbodyResult.filter(
            (item: any) => item.DataBeanProperties[keyId] !== id
        );
        setMbodyResult(updatedMultiValue);
    };

    const onChangeCheckbox = (bean) => {
        const id = bean.DataBeanProperties[keyId];
        setMbodyResult((prev) => {
            const isSelected = prev.some((item) => item.DataBeanProperties[keyId] === id);
            if (isSelected) {
                return prev.filter(item => item.DataBeanProperties[keyId] !== id);
            }
            return [...prev, { DataBeanProperties: { ...bean.DataBeanProperties } }];
        });
    };

    const [temporalPage, setTemporalPage] = useState<string | number>("1");
    useEffect(() => { if (page != temporalPage) setTemporalPage(page) }, [page])

    const [usePage, setUsePage] = useState<number>(records?.page);
    useEffect(() => {
        if (!isNaN(records?.page) && records?.page >= 1 && records.page != usePage) {
            setUsePage(records?.page)
        }
    }, [records?.page])

    const sums = useMemo(() => {
        if (!sumPropsList || mbodyResult.length === 0) return {};

        const result: any = {};

        sumPropsList.forEach((item: any) => {
            result[item.property] = mbodyResult.reduce((acc, row) => {
                const value = Number(row.DataBeanProperties[item.property]) || 0;
                return acc + value;
            }, 0);
        });

        return result;
    }, [mbodyResult, sumPropsList]);



    return (
        <>
            <div className="row mb-2">
                <div className="col-md-12">
                    {headButtons}
                </div>
                <div className="col-md-12">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                        {/* Botones de Paginación */}
                        <div className="d-flex align-items-center gap-2">
                            {records ? (
                                <>
                                    {(back && records.page > 1) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={back}
                                        >
                                            Anterior
                                        </button>
                                    )}

                                    <span style={{ padding: '5px' }}>
                                        <input
                                            type="number"
                                            className="form-control d-inline-block"
                                            style={{ width: "60px", textAlign: "center", display: "inline", height: "35px" }}
                                            value={usePage}
                                            min={1}
                                            max={records.pages}
                                            onChange={(e) => {
                                                const valueEdit = e.target.value ? Number(e.target.value) : null;
                                                setUsePage(valueEdit);
                                            }}
                                            onBlur={(e) => {
                                                const pageData = Number(e.target.value);
                                                if (!isNaN(pageData) && pageData >= 1 && pageData <= records.pages) {
                                                    setUsePage(pageData);
                                                    records.setPage?.(pageData);
                                                } else {
                                                    toast.error("Debe digitar una página válida");
                                                }
                                            }}
                                        />
                                        <span className="ms-2">de {records.pages}</span>
                                    </span>
                                    {(next && records.page < records.pages) && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={next}
                                        >
                                            Siguiente
                                        </button>
                                    )}
                                </>
                            ) : (
                                <>
                                    {page > 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setPage(page - 1)}
                                        >
                                            Anterior
                                        </button>
                                    )}

                                    <span style={{ padding: '5px' }}>
                                        <input
                                            type="number"
                                            className="form-control d-inline-block"
                                            style={{ width: "60px", textAlign: "center", display: "inline", height: "35px" }}
                                            value={temporalPage}
                                            onChange={(e) => setTemporalPage(e.target.value)}
                                            onBlur={() => {
                                                const pageData = Number(temporalPage);
                                                if (!isNaN(pageData) && pageData >= 1 && pageData <= Math.ceil(body.length / rows)) {
                                                    setPage(pageData);
                                                } else {
                                                    toast.error("Debe digitar una página válida");
                                                    setTemporalPage(page);
                                                }
                                            }}
                                        />
                                        <span className="ms-2">de {Math.ceil(body.length / rows)}</span>
                                    </span>

                                    {Math.floor(page * rows) < body.length && (
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm"
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Siguiente
                                        </button>
                                    )}
                                </>
                            )}
                        </div>

                        {/* Cantidad de Registros */}
                        <div className="text-end">

                            <span>
                                Registros: {records?.records ?? body.length}
                                {mbodyResult.length > 0 && (
                                    <> | Seleccionados: {mbodyResult.length}</>
                                )}
                            </span>

                            {sumPropsList?.map((item: any) => (
                                item.visible && (
                                    <span key={item.property} style={{ marginLeft: 10 }}>
                                        {item.title}: {sums[item.property]?.toLocaleString()}
                                    </span>
                                )
                            ))}

                        </div>
                    </div>
                </div>
            </div>

            <div className={cssTable ?? "table-responsive1"}>
                <table className="table table-striped-columns" id="tabla"  >
                    <HeadMultiSelectTable titulo={titulo} body={mbody} mbodyResult={mbodyResult} keyId={keyId} onChange={(e) => setMbodyResult(e)} />
                    <tbody >
                        {Array.isArray(mbody) &&
                            mbody.map((bean: any, index: number) => {
                                const isSelected = mbodyResult.some(
                                    (item: any) => item.DataBeanProperties[keyId] === bean.DataBeanProperties[keyId]
                                );
                                return (
                                    <tr key={bean.DataBeanProperties[keyId]}
                                        className={`cursor ${currentIndex === index ? "table-primary text-primary" : ""}`}
                                        onClick={() => {
                                            setCurrentIndex(index);
                                            onChangeCheckbox(bean);
                                            setRowBean?.(bean.DataBeanProperties)
                                            console.log(bean.DataBeanProperties)
                                        }}
                                    >
                                        <td className="checkbox-col">
                                            <input
                                                type="checkbox"
                                                id={`checkbox-${bean.DataBeanProperties[keyId]}`}
                                                checked={isSelected}
                                                onChange={(e) => e.stopPropagation()}
                                            />
                                        </td>
                                        {titulo.map((item: any) =>
                                            item.visible && (
                                                <td key={item.id || item.title} onClick={() => { }}>
                                                    <TableMultiSelectCell head={item} cell={bean.DataBeanProperties} returnValue={(e) => { onClickCell(e) }} />
                                                </td>
                                            )
                                        )}
                                    </tr>
                                )
                            })
                        }
                        {Array.isArray(mbody) && mbody.length === 0 &&
                            <tr>
                                <td colSpan={head.length}>
                                    No hay datos para mostrar.
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>

    )
}
